import { ICenterCoordinator, IContact, IListItem, IRecipientProfileHlaValues } from '@nkr/models/index';

export interface ILookupData {
    stateList: IListItem[],
    voucherStatusList: IListItem[],
    coordinatorList: ICenterCoordinator[],
    recipientInactiveReasonList: IListItem[],
    compatiblePairKpdReasonList: IListItem[],
    deleteReasonList: IListItem[],
    insuranceGroupList: IListItem[],
    hlaValueList: IRecipientProfileHlaValues[]
    raceList: IListItem[],
    antiATiterValueList: IListItem[],
    contactList: IContact[]
}